export default [
  { key: 'name', tdClass: 'align-middle' },
  { key: 'title', tdClass: 'align-middle' },
  { key: 'type', tdClass: 'align-middle' },
  { key: 'createdAt', label: 'Created', tdClass: 'align-middle' },
  { key: 'updatedAt', label: 'Updated', tdClass: 'align-middle' },
  { key: 'actions', label: ' ', tdClass: 'text-nowrap align-middle text-center' },
];
